import * as React from 'react';

import { Grid, Stack, AppBar, Toolbar, Button, Typography, styled } from '@mui/material';

import SkypadLogo from "../../components/Logo/skypad_walmart.png";

const SyledFooterButton = styled(Button)({
  background: 'white', borderRadius: '20px', color: "#54B948", fontSize: '19px !important',
  fontWeight: 'bold',
  padding: '10px 20px 12px 20px',
  border: '1px solid',
  '&:hover': { background: '#54B948', color: 'white', border: '1px solid' }
});

export default function Header({ logout }) {

  return (
    <AppBar position="static" sx={{ backgroundColor: "#54B948", padding: "50px 40px" }}>
      <Toolbar>
        <Grid container spacing={2}>
          <Grid item xs={12} md={7.5}>
            <Stack direction="row" spacing={2}>
              <img src={SkypadLogo} style={{
                height: '50px',
                margin: 'auto'
              }} />
              <Typography variant="h1" fontWeight={100} component="div"
                sx={{ flexGrow: 1, color: 'white', margin: '0px 20px 0px 10px', fontSize: '55px', marginLeft:'10px !important' }}>
                Integrations
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} md={4.5} textAlign={'end'}>
            <div>
              <SyledFooterButton variant="contained" size="large" onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
                Log Out
              </SyledFooterButton>
            </div>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
